<div style="margin: 10px">
  <div class="grid align-items-end" style="margin-bottom: 20px !important">
    <div class="col-1" *ngIf="mostrarBtnAgregar">
      <button type="button" pButton
              icon="fa fa-plus"
              label="{{ 'BTN_AGREGAR' | translate }}"
              class="btn-primary-full w-full"
              (click)="crear()">
      </button>
    </div>
    <div class="col-3">
      <div class="div-form mb-0">
        <input type="text" pInputText
               placeholder="{{ 'LBL_BUSCAR' | translate }}"
               [value]="busqueda"
               (input)="buscar( $event.target.value )">
      </div>
    </div>
  </div>

  <p-table #dt
           [columns]="columnas"
           [value]="registrosFiltrados"
           [loading]="cargando"
           selectionMode="single"
           dataKey="idGarantiaIdoneaModalidad"
           [paginator]="true"
           [rows]="10"
           paginatorPosition="bottom"
           styleClass="table-premium"
           responsiveLayout="scroll"
           [tableStyle]="{'min-width': '1200px'}">

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns"
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            class="text-center">
          {{ col.header | translate }}
          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr [pSelectableRow]="row">
        <td class="text-center">{{ row.modalidadGarantia }}</td>
        <td class="text-center">{{ row.tipoGarantia }}</td>
        <td class="text-center">{{ row.otraGarantia }}</td>
        <td class="text-center">{{ row.bienDeDerecho }}</td>
        <td class="text-center">{{ row.endeudamientoSMLV }}</td>
        <td class="text-center">{{ row.maximoFinanciar !== null ? (row.maximoFinanciar + '%') : '--' }}</td>
        <td class="text-center">{{ row.minimoCompraLeasing !== null && row.codigoOtraGarantia === codigosGarantias.LEASIN ? (row.minimoCompraLeasing + '%') : '--' }}</td>
        <td class="text-center">{{ row.maximoCompraLeasing !== null && row.codigoOtraGarantia === codigosGarantias.LEASIN ? (row.maximoCompraLeasing + '%') : '--' }}</td>
        <td class="text-center">
          {{ row.fechaActivacion ? (row.fechaActivacion | date: 'dd/MM/yyyy HH:mm') : '--' }}
        </td>
        <td class="text-center">
          {{ row.fechaInactivacion && !row.indicadorHabilitado ? (row.fechaInactivacion | date: 'dd/MM/yyyy HH:mm') : '--/--/--' }}
        </td>
        <td class="text-center">
          <span *ngIf="row.indicadorHabilitado" class="badge-habilitado">
            {{ 'ADMGAR.LBL_HABILITADO' | translate | uppercase }}
          </span>
          <span *ngIf="!row.indicadorHabilitado" class="badge-inhabilitado">
            {{ 'ADMGAR.LBL_INHABILITADO' | translate | uppercase }}
          </span>
        </td>
        <td class="text-center" *ngIf="mostrarBtnAcciones">
          <button type="button" pButton
                  class="btn-action-premium"
                  icon="fa fa-pencil"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  (click)="editar( row )">
          </button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns?.length || 1" class="text-center">
          {{ 'MSG_NOHAYREGISTROS' | translate }}
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>

<p-confirmDialog #cdUnsavedIdonea
                 key="unsaved_idonea"
                 [style]="{width: '420px'}"
                 acceptLabel="Sí"
                 rejectLabel="No"
                 acceptIcon="fa fa-check"
                 rejectIcon="fa fa-times"
                 acceptButtonStyleClass="btn-primary-full"
                 rejectButtonStyleClass="btn-primary-outline">
</p-confirmDialog>

<p-dialog *ngIf="mostrarModal"
          [(visible)]="mostrarModal"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [style]="{width: '860px', 'max-width': '96vw'}"
          styleClass="admgar-modal-garantia"
          class="overflow-y-unset">

  <ng-template pTemplate="header">
    <div class="admgar-modal-header">
      <span class="admgar-modal-titulo">{{ (registroEditando ? 'LBL_EDITAR' : 'LBL_AGREGAR') | translate | uppercase }}  {{ 'ADMGAR.IDONEA_TITULO' | translate }}</span>
      <button type="button" class="admgar-modal-cerrar" (click)="cerrarModal()" title="Cerrar">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </ng-template>

  <p-tabView [(activeIndex)]="tabEditarActiva"
             styleClass="admgar-tabs"
             (onChange)="onCambiarTab($event)">

    <p-tabPanel *ngIf="mostrarTabConfiguracion"
                [header]="'ADMGAR.TAB_CONFIGURACION' | translate">
      <ng-container *ngTemplateOutlet="camposFormTpl"></ng-container>
    </p-tabPanel>

    <p-tabPanel *ngIf="modoEdicion && mostrarTabHistorial"
                [header]="'ADMGAR.TAB_HISTORIAL' | translate">

      <p-table [value]="historialCambios"
               [loading]="cargandoHistorial"
               [paginator]="true"
               [rows]="10"
               paginatorPosition="bottom"
               styleClass="table-premium"
               responsiveLayout="scroll">

        <ng-template pTemplate="header">
          <tr>
            <th style="width:24%;">{{ 'ADMGAR.COL_CAMPO' | translate }}</th>
            <th class="text-center" style="width:18%;">{{ 'ADMGAR.COL_VALOR_ANTERIOR' | translate }}</th>
            <th class="text-center" style="width:18%;">{{ 'ADMGAR.COL_VALOR_NUEVO' | translate }}</th>
            <th class="text-center" style="width:20%;">{{ 'ADMGAR.COL_USUARIO' | translate }}</th>
            <th class="text-center" style="width:20%;">{{ 'ADMGAR.COL_FECHA' | translate }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.campo }}</td>
            <td class="text-center">{{ row.valorAnterior }}</td>
            <td class="text-center">{{ row.valorNuevo }}</td>
            <td class="text-center">{{ row.nombreUsuario }}</td>
            <td class="text-center">{{ row.auditoriaFecha | date:'dd/MM/yyyy HH:mm' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center admgar-historial-vacio">
              {{ 'ADMGAR.MSG_SIN_HISTORIAL' | translate }}
            </td>
          </tr>
        </ng-template>

      </p-table>

    </p-tabPanel>

  </p-tabView>

  <ng-template pTemplate="footer">
    <div *ngIf="mostrarTabConfiguracion && tabEditarActiva === 0" class="admgar-modal-footer">
      <button type="button" pButton
              label="{{ 'BTN_CANCELAR' | translate }}"
              class="btn-primary-outline"
              (click)="cancelar()">
      </button>
      <button type="button" pButton
              icon="fa fa-check-circle"
              label="{{ 'BTN_GUARDAR' | translate }}"
              class="btn-primary-full"
              [disabled]="guardando"
              (click)="guardar()">
      </button>
    </div>
  </ng-template>

</p-dialog>

<ng-template #camposFormTpl>
  <form [formGroup]="formulario" novalidate class="admgar-formulario mt-3">

    <div class="grid admgar-form-fila">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_MODALIDAD' | translate }}</label>
          <p-dropdown formControlName="idModalidadGarantia"
                      [options]="lisModalidades"
                      placeholder="{{ 'ADMGAR.PLACEHOLDER_SELECCIONAR' | translate }}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}" *ngIf="!registroEditando">
          </p-dropdown>
          <label class="falso-combo-texto" *ngIf="registroEditando">{{ registroEditando.modalidadGarantia }}</label>
          <small class="admgar-error" *ngIf="submitted && f.idModalidadGarantia.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_TIPO_GARANTIA' | translate }}</label>
          <p-dropdown formControlName="idTipoGarantia"
                      [options]="lisTiposGarantia"
                      placeholder="{{ 'ADMGAR.PLACEHOLDER_SELECCIONAR' | translate }}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}" *ngIf="!registroEditando">
          </p-dropdown>
          <label class="falso-combo-texto" *ngIf="registroEditando">{{ registroEditando.tipoGarantia }}</label>
          <small class="admgar-error" *ngIf="submitted && f.idTipoGarantia.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label class="admgar-campo-label--invisible">&#8203;</label>
          <div class="admgar-switch-row flex align-items-center gap-2" style="height: 38px;">
            <p-inputSwitch formControlName="indicadorHabilitado"></p-inputSwitch>
            <span class="admgar-switch-texto">{{ 'ADMGAR.LBL_HABILITADO' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="grid admgar-form-fila">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_CLASE_GARANTIA' | translate }}</label>
          <p-dropdown formControlName="idOtraGarantia"
                      [options]="lisClasesGarantia"
                      placeholder="{{ 'ADMGAR.PLACEHOLDER_SELECCIONAR' | translate }}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}" *ngIf="!registroEditando">
          </p-dropdown>
          <label class="falso-combo-texto" *ngIf="registroEditando">{{ registroEditando.otraGarantia }}</label>
          <small class="admgar-error" *ngIf="submitted && f.idOtraGarantia.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_BIEN_DERECHO' | translate }}</label>
          <p-dropdown formControlName="idBienDeDerecho"
                      [options]="lisBienesDerechos"
                      placeholder="{{ 'ADMGAR.PLACEHOLDER_SELECCIONAR' | translate }}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                      [style]="{width:'100%'}" *ngIf="!registroEditando">
          </p-dropdown>
          <label class="falso-combo-texto" *ngIf="registroEditando">{{ registroEditando.bienDeDerecho }}</label>
          <small class="admgar-error" *ngIf="submitted && f.idBienDeDerecho.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_ENDEUDAMIENTO_SMLV' | translate }}</label>
          <input pInputText type="text" autocomplete="off" formControlName="endeudamientoSMLV" placeholder="Ingresar" numero-decimal-rango-reactive
                 [decimales]="2" [entero]="6">
          <small class="admgar-error" *ngIf="submitted && f.endeudamientoSMLV.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>
    </div>

    <div class="grid admgar-form-fila">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_MAX_FINANCIAR' | translate }}</label>
          <input pInputText type="text" autocomplete="off" formControlName="maximoFinanciar" placeholder="Ingresar" numero-decimal-rango-reactive
                 [maximo]="100" [decimales]="2" [entero]="3">
          <small class="admgar-error" *ngIf="submitted && f.maximoFinanciar.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4" *ngIf="esLeasing">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_MIN_COMPRA_LEASING' | translate }}</label>
          <input pInputText type="text" autocomplete="off" formControlName="minimoCompraLeasing" placeholder="Ingresar" numero-decimal-rango-reactive
                 [decimales]="2" [entero]="2">
          <small class="admgar-error" *ngIf="submitted && f.minimoCompraLeasing.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-4" *ngIf="esLeasing">
        <div class="div-form">
          <label>*{{ 'ADMGAR.LBL_MAX_COMPRA_LEASING' | translate }}</label>
          <input pInputText type="text" autocomplete="off" formControlName="maximoCompraLeasing" placeholder="Ingresar" numero-decimal-rango-reactive
                 [decimales]="2" [entero]="2">
          <small class="admgar-error" *ngIf="submitted && f.maximoCompraLeasing.errors?.required">
            {{ 'ADMGAR.MSG_CAMPO_REQUERIDO' | translate }}
          </small>
        </div>
      </div>

      <div class="col-12" *ngIf="errorMinMaxLeasing && esLeasing">
        <small class="admgar-error" style="display:block; margin-bottom: 8px;">
          <i class="fa fa-exclamation-circle"></i>
          {{ 'ADMGAR.MSG_MIN_MAYOR_MAX_LEASING' | translate }}
        </small>
      </div>

      <div class="col-12" *ngIf="errorDuplicado">
        <small class="admgar-error" style="display:block; margin-bottom: 8px;">
          <i class="fa fa-exclamation-circle"></i>
          {{ 'ADMGAR.MSG_IDONEA_DUPLICADA' | translate }}
        </small>
      </div>
    </div>

  </form>
</ng-template>
